module.exports = __webpack_public_path__ + "static/media/Anticelulitidni_gel_retina.ce5f4bd6.jpg";